import { render } from "./QuestionMap.vue?vue&type=template&id=d60a6866"
import script from "./QuestionMap.vue?vue&type=script&lang=js"
export * from "./QuestionMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__